
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M2.5 7.5C2.5 7.5 3.12437 8.85288 4.73586 10.1512M21.5 7.5C21.5 7.5 20.9369 8.72013 19.5 9.95493M14.343 12.3081C13.627 12.4306 12.8474 12.5 12 12.5C11.0903 12.5 10.2587 12.42 9.5 12.2803M14.343 12.3081L15.5 16.5M14.343 12.3081C16.7021 11.9047 18.3708 10.9253 19.5 9.95493M19.5 9.95493L22.5 13M9.5 12.2803L8.5 16.5M9.5 12.2803C7.38066 11.8899 5.83052 11.0331 4.73586 10.1512M4.73586 10.1512L2 13"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiHide",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
